module.exports = __webpack_public_path__ + "static/IBMPlexMono-Regular-3bbb37eb2e29eed031eaaf63664b21aa.woff";